import { MemberService } from '../services/member.service';
import { HotelService } from '../services/hotel.service';
import { ReservationService } from '../services/reservation.service';
import { LogService } from '../services/logging.service';
import { Actions } from '../../store/actions';
import { AppAction, AppActionState, IAppState } from '../../store/interfaces/IAppState';
import { NgRedux } from '@angular-redux/store';
import { CommonActionsDelegate } from './common-actions.delegate';
import { Inject, Injectable } from '@angular/core';
import { IAppConfig } from '../../store/interfaces';
import { APP_CONFIG } from '../config';
import { Reservation } from '../model/reservation';

@Injectable()
export class ManageStayDelegate extends CommonActionsDelegate {
  private CLASS_NAME = 'ManageStayDelegate';
  constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig,
    _ngRedux: NgRedux<IAppState>,
    _actions: Actions,
    _logService: LogService,
    _reservationService: ReservationService,
    _hotelService: HotelService,
    _memberService: MemberService) {
    super(_ngRedux, _actions, _logService, _reservationService, _hotelService, _memberService);
  }

  retrieveReservation(confirmationNumber: string, lastName: string) {
    this._reservationService.getReservation(confirmationNumber, lastName)
      .subscribe((reservation: Reservation) => {
          this._actions.dispatchReservationAction(AppAction.GET_RESERVATION, AppActionState.SUCCESS, reservation);
      },
        error => {
          this._logService.error(`Error retrieving all reservation information. Reservation: ${confirmationNumber}`, this.CLASS_NAME, error);
          this._actions.dispatchReservationAction(AppAction.GET_RESERVATION, AppActionState.ERROR, null, error);
        },
        () => {
          this._logService.info('Retrieved all reservation information', this.CLASS_NAME, confirmationNumber);
        });
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/delegates/manage-stay.delegate.ts